export type Nullable<T> = {
  [P in keyof T]: T[P] extends object
    ? T[P] extends Array<infer U>
      ? Array<Nullable<U>>
      : Nullable<T[P]> | null
    : T[P] | null;
};

export type UpdateTab = "INFOS" | "RISK_FACTORS" | "GENERAL_HEALTH" | "HYGIENE";

export const updateTabChoices: Array<{ label: string; value: UpdateTab }> = [
  {
    label: "Informations",
    value: "INFOS",
  },
  {
    label: "Facteurs de risque",
    value: "RISK_FACTORS",
  },
  {
    label: "Santé générale",
    value: "GENERAL_HEALTH",
  },
  {
    label: "Hygiène de vie",
    value: "HYGIENE",
  },
];

export type PatientTab = "DASHBOARD" | "DOCUMENTS" | "PERIOTOOLS" | "HISTORY";

export const patientTabChoices: Array<{ label: string; value: PatientTab }> = [
  {
    label: "Prise en charge",
    value: "DASHBOARD",
  },
  {
    label: "Periotools",
    value: "PERIOTOOLS",
  },
  {
    label: "Documents",
    value: "DOCUMENTS",
  },
  {
    label: "Suivi",
    value: "HISTORY",
  },
];
